export const hassleFlags = [{
  flag: 'had_hassle_admin',
  label: 'Admin had hassle'
}, {
  flag: 'had_hassle_client',
  label: 'Client had hassle'
}];

/** Billing flags GTI Hub owns for its projects (read-only here on those). */
export const hubManagedBillingFlags = ['is_proof_of_concept', 'is_research_and_development', 'is_excluded_from_billing'];
export const billingFlags = [{
  flag: 'is_proof_of_concept',
  label: 'POC Project'
}, {
  flag: 'is_research_and_development',
  label: 'R&D Project'
}, {
  flag: 'is_excluded_from_billing',
  label: 'Exclude from billing'
}, {
  flag: 'can_be_charged',
  label: 'Can be charged'
}, {
  flag: 'can_be_billed',
  label: 'Can be billed'
}];
export const miscFlags = [{
  flag: 'is_excluded_from_slack_notifications',
  label: 'Exclude from slack notifications'
}, {
  flag: 'is_excluded_from_stats',
  label: 'Exclude from margin reporting'
}, {
  flag: 'is_excluded_from_admin_dashboard',
  label: 'Exclude from admin dashboard'
}, {
  flag: 'can_be_matched',
  label: 'Can be matched'
}];